export default __webpack_public_path__ + "static/banner_back-bfef61fd511ac1f6129c75d9d51de0af.webp";